import { FC } from 'react';
import TrainingHopSentence from '../Modecules/TrainingHopSentence';
import { TrainingInfoSentences } from '../../types/apis/trainingInfoApi';

import styles from './TrainingSentences.module.scss';

type Props = {
  // センテンスのデータ
  sentenceData: TrainingInfoSentences[];
  // 現在の再生時間
  currentTime: number;
};

const TrainingHopSentences: FC<Props> = ({ sentenceData, currentTime }) => (
  <div className={`${styles['training-sentences']} ${styles['mod-training']}`}>
    <div className={styles['training-sentences-outer']}>
      {sentenceData.map((item) => (
        <TrainingHopSentence
          key={item.english.id}
          currentTime={currentTime}
          englishSentence={{
            startTime: item.english.start,
            endTime: item.english.end,
            text: item.english.text,
          }}
          japaneseSentence={
            item.japanese
              ? {
                  startTime: item.japanese.start,
                  endTime: item.japanese.end,
                  text: item.japanese.text,
                }
              : null
          }
        />
      ))}
    </div>
  </div>
);

export default TrainingHopSentences;
